import { render, staticRenderFns } from "./EmptyCart.vue?vue&type=template&id=7388fd62&scoped=true"
import script from "./EmptyCart.vue?vue&type=script&lang=js"
export * from "./EmptyCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7388fd62",
  null
  
)

export default component.exports